import { createSlice } from '@reduxjs/toolkit'

const ourClassesStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: ourClassesStatus.LOADING,
    errorMessage: null,
    classes: [],
}

const ourClassesSlice = createSlice({
    name: 'ourClasses',
    initialState,
    reducers: {
        getOurClasses: state => {
            state.status = ourClassesStatus.LOADING
        },
        getOurClassesSuccess: (state, action) => {
            state.classes = action.payload
            state.status = ourClassesStatus.SUCCESS
        },
        getOurClassesError: (state, action) => {
            state.errorMessage = action.payload
            state.status = ourClassesStatus.FAILURE
        },
    },
})

const {
    getOurClasses,
    getOurClassesSuccess,
    getOurClassesError,
} = ourClassesSlice.actions

export const ourClassesActions = {
    getOurClasses,
    getOurClassesSuccess,
    getOurClassesError,
}

export const ourClassesSelectors = {
    isFetching: state => state.ourClasses.status === ourClassesStatus.LOADING,
    errorMessage: state => state.ourClasses.errorMessage,
    hasError: state => state.ourClasses.status === ourClassesStatus.FAILURE,
    classes: state => state.ourClasses.classes,
}

export const ourClassesReducer = ourClassesSlice.reducer
